// 計畫專區頁面
export const Plan = () => {
  return (
    <div>
      <div className="mb-16">
        <div className="flex items-center staticBanner bg-[#ACDFF0] relative">
          <div className="staticBannerContent">
            <img
              src="/images/planBanner.png"
              alt="banner"
              className="staticBannerImg"
            />
          </div>
        </div>
        <div className="content px-4 mx-auto pt-2">
          <div className=" mt-12 md:mt-16">
            <iframe src="https://affairs.kh.edu.tw/6856/upload/upload_list/85" style={{ width: '100%', height: '70vh', display: 'block', padding: '0', margin: '0' }}></iframe>
          </div>
        </div>


        {/* <div className="staticSection">
          <div className="sectionContent">
            <h3 className="sectionTitle text-Headline">雙語計畫區</h3>
            <ul className="space-y-[2em] text-text text-sm sm:text-base lg:text-2xl">
              <li className="">
                <ol className="flex flex-col gap-4 ps-[2em] list-disc mt-[0.5em]">
                  <li>國際文教論壇：亞洲學生交流計畫、日本名古屋世界青年高峰會、港都菁英模擬聯合國</li>
                  <li>協辦雙語教育：外國學生合作計畫、高雄英語行動車計畫、雙語特色學校關懷輔導計畫</li>
                  <li>國際英語村</li>
                  <li>國際扶輪3510地區偏鄉英語線上課業輔導合作事宜</li>
                </ol>
              </li>
            </ul>

          </div>
        </div>
        <div className="staticSection">
          <div className="sectionContent">
            <h3 className="sectionTitle text-Headline">數位計畫區</h3>
            <ul className="space-y-[2em] text-text text-sm sm:text-base lg:text-2xl">
              <li className="">
                <ol className="flex flex-col gap-4 ps-[2em] list-disc mt-[0.5em]">
                  <li>推動中小學數位學習精進方案-中小學實施計畫</li>
                  <li>推動中小學數位學習精進方案-高級中等學校實施計畫</li>
                  <li>數位學習專業社群計畫</li>
                  <li>數位學習支持關懷計畫</li>
                  <li>入校入班（手把手）陪伴計畫</li>
                  <li>恆星暨校長科技領導學校實施計畫</li>
                  <li>特殊教育數位學習實驗教師計畫</li>
                  <li>AIGC數位學習實驗教師計畫</li>
                  <li>AI師資培育發展專業發展學校實施計畫</li>
                </ol>

                <img
                  src="/images/architecture5.jpg"
                  alt="規劃培訓教師應用數位科技進行教學，並精進教師數位教學能力"
                  className="py-[1em]"
                />
              </li>
            </ul>
          </div>
        </div> */}

      </div>
    </div>
  );
};
